<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="editedProject != undefined"
      :class="{
        opened: opened.indexOf('parameters') >= 0,
        'last-active': opened.indexOf('parameters') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <div>
          <button v-if="apiUser.isCustomerAdmin" class="btn btn-primary" @click="runEdit()">
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
            </div>
            {{ $t("ulozit") }}
          </button>
        </div>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("detailProjektu") }} {{ project.projectName }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.project" class="text-danger">
          {{ errors.project }}
        </div>
        <div class="my-4">
          <a
            :class="{ opened: infoOpened }"
            class="atom-form-group__toggler"
            @click="infoOpened = infoOpened ? false : true"
          >
            {{ $t("informaceOProjektu") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: infoOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{ $t("idProjektu") }}</span>
              <div
                :class="{
                  'has-error': errors.project && !editedProject.projectId,
                  disabled: true
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!editedProject.projectId" class="placeholder">{{ $t("zadejteIdProjektu") }}</span>
                <input v-model="editedProject.projectId" autofocus class="w-100" disabled placeholder="" type="text" />
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{ $t("nazevProjektu") }}</span>
              <div
                :class="{
                  'has-error': errors.project && !editedProject.projectName,
                  disabled: apiUser.isCustomerAdmin ? false : true
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!editedProject.projectName" class="placeholder">{{ $t("zadejteNazevProjektu") }}</span>
                <input
                  v-model="editedProject.projectName"
                  :disabled="apiUser.isCustomerAdmin ? false : true"
                  autofocus
                  class="w-100"
                  maxlength="30"
                  minlength="1"
                  placeholder=""
                  type="text"
                  @click="changedEvent"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: countersOpened }"
            class="atom-form-group__toggler"
            @click="countersOpened = countersOpened ? false : true"
          >
            {{ $t("aktualniPoctyZaObdobi") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: countersOpened }" class="atom-form-group__content">
            <div
              v-for="counter in counters"
              :key="counter.counterId"
              class="side-box__row d-flex align-items-start mt-3"
            >
              <span class="side-box__content__label side-box__content__label--large text gray-text">
                {{ $t(counter.name) }}
              </span>
              <span class="side-box__content__value ml-3">
                {{ counter.value >= 2147483626 ? $t("neomezene") : counter.value }}
              </span>
            </div>
          </div>
        </div>

        <div v-if="editedProject.parameters" class="my-4">
          <a
            :class="{ opened: parametersOpened }"
            class="atom-form-group__toggler"
            @click="parametersOpened = parametersOpened ? false : true"
          >
            {{ $t("parametryProjektu") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div
            v-if="editedProject.parameters.length > 0"
            :class="{ opened: parametersOpened }"
            class="atom-form-group__content"
          >
            <div v-if="!apiUser.isReseller">
              <div
                v-for="(paramName, index) in parametersNames"
                :key="index + 'c'"
                class="side-box__row d-flex align-items-start mt-3"
              >
                <span class="side-box__content__label side-box__content__label--large text gray-text">
                  {{ $t(getParameter(paramName).name) }}
                </span>
                <span class="side-box__content__value ml-3">{{ getParameter(paramName).value }}</span>
              </div>
            </div>
            <div v-if="apiUser.isReseller">
              <div
                v-for="(paramName, index) in parametersNames"
                :key="index"
                class="side-box__row d-flex align-items-center mt-3"
              >
                <span class="side-box__content__label">{{ $t(getParameter(paramName).name) }}</span>
                <div v-if="privileges" class="side-box__content__input side-box__content__input--large ml-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="custom-control__custom-input">
                      <input
                        v-model.lazy="getParameter(paramName).value"
                        :disabled="getParameter(paramName + '_IS_INDEF').value == 1"
                        :type="getParameter(paramName).type"
                        autofocus
                        class="w-100"
                        placeholder=""
                      />
                    </div>
                    <div v-if="getParameter(paramName + '_IS_INDEF')" class="ml-2 pointer d-flex align-items-center">
                      <div
                        :class="{
                          checked: getParameter(paramName + '_IS_INDEF').value == 1
                        }"
                        class="ml-sm-3 custom-control custom-control--checkbox"
                        @click="setParam(paramName + '_IS_INDEF')"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      {{ $t("bezOmezeni") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleConfirmation"
      @no="closeBox('parameters')"
      @yes="runEdit()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="closeModalError()" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useAdminStore } from "@/store/modules/admin"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    project: Object,
    opened: Array
  },
  setup() {
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()
    const projectStore = useProjectStore()
    const adminStore = useAdminStore()

    return { customerStore, authStore, projectStore, adminStore }
  },
  data() {
    return {
      changed: false,
      parametersOpened: true,
      countersOpened: true,
      infoOpened: true,
      projects: [],
      usersProjects: [],
      params: [],
      counters: [],
      errors: {
        project: ""
      },
      parametersNames: [
        "COUNTER-DEV_LMT_ACTUAL",
        "COUNTER-IN_MSG_LMT_USR",
        //"COUNTER-MSG_LMT_USR_PERIOD",
        "COUNTER-OUT_MSG_LMT_USR"
      ],
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false,
      privileges: []
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    user() {
      return this.authStore.user
    },
    editedProject() {
      return Object.assign({}, this.project)
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {
    storedCustomer() {
      this.loadCounters()
      this.editedProject = Object.assign(this.project)
    }
  },
  mounted() {
    this.loadCounters()
    //this.editedProject = Object.assign(this.project);

    console.log("apiUser", this.apiUser)
  },
  methods: {
    closeModalError() {
      this.openedError = false
    },
    changedEvent() {
      this.changed = true
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "parameters") {
        this.$emit("closeBox", box)
      } else {
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    async runEdit() {
      console.log("runEdit()")
      if (!this.editedProject.projectId) {
        this.errors.project = "Vyplňte všechna označená pole."
      } else {
        this.errorsToTranslate = []
        this.errors.project = ""
        await this.saveProject()

        if (this.editedProject) {
          if (!this.errorsToTranslate.length) {
            this.$emit("reloadProjects")
            this.$emit("closeBox", "parameters")
          }
        }
      }
    },
    saveProject() {
      console.log("saveProject()")
      console.log(this.editedProject)
      return axios
        .put(process.env.VUE_APP_API + "/projects/" + this.project.projectId, {
          projectName: this.editedProject.projectName
        })
        .then(() => {
          this.adminStore.setProject(this.editedProject)
          /**
           * reload projects
           */
          this.projectStore.getProjectList()
          /**
           * set current project
           */
          let selectedProject = JSON.parse(localStorage.getItem("selectedProject"))
          if (this.project.projectId == selectedProject.projectId) {
            selectedProject.projectName = this.editedProject.projectName
            this.projectStore.setProject(selectedProject)
            localStorage.setItem("selectedProject", JSON.stringify(selectedProject))
          }
          this.$emit("reloadProjects")
          return true
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          return true
        })
    },
    toggleConfirmation() {
      if (this.changed) {
        this.openedConfirmation = this.openedConfirmation ? false : true
      } else {
        this.openedConfirmation = false
        this.$emit("closeBox", "parameters")
      }
    },
    getParameter(name) {
      let param = this.editedProject.parameters.filter((parameter) => parameter.name == name)
      return param.length > 0 ? param[0] : null
    },
    setParam(name) {
      console.log(name)
      let param = this.editedProject.parameters.filter((parameter) => parameter.name == name)
      console.log(param)
      param[0].value = param[0].value == 1 ? "0" : "1"
      console.log(param)
    },
    loadCounters() {
      this.counters = []
      axios
        .get(process.env.VUE_APP_API + "/projects/" + this.project.projectId + "/counters?limit=1000")
        .then((result) => {
          this.counters = result.data.data
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
